import { Config } from "./contexts/ConfigurationContext";

export const configuration: Config = {
  corpusKey: "parable_group",
  customerId: "2144887138",
  appTitle: "apg-suggest",
  apiKey: "zqt_f9hhYoY5C0qsSamEbaG7yb-aJtUS9nKduO6vgw",
  endpoint: "api.vectara.io",
  questions: ["What are some good books about dealing with anxiety?"],
};
